<script setup lang="ts">
const props = withDefaults(defineProps<{ name: string; size?: number }>(), { size: 44 })
const initials = props.name.trim().split(/\s+/).slice(0, 2).map((part) => part[0]?.toUpperCase() ?? '').join('')
</script>

<template>
  <span class="ck-avatar" :style="{ width: `${size}px`, height: `${size}px`, fontSize: `${size * 0.36}px` }">{{ initials }}</span>
</template>

<style scoped>
.ck-avatar { display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; border-radius: var(--radius-full); background: var(--ck-flame); color: white; font-family: var(--font-display); font-weight: 800; }
</style>
